module.exports = __webpack_public_path__ + "img/volt-logo.0c46efd7.svg";